import { OutboundConfigGQL } from '@schema';
import { QueryData } from '@shared/apollo/query-actions';
import { NamingConfig } from '@shared/naming/naming-config';

export type OutboundConfig = Omit<
  QueryData<OutboundConfigGQL, ['outboundConfigs']>[number],
  '__typename'
>;

export const OutboundConfigNaming = NamingConfig<OutboundConfig>({
  key: 'OutboundConfig',
  modelName: { '=1': $localize`Outbound Config`, other: $localize`Outbound Configs` },
  fieldNames: {
    id: $localize`ID`,
    name: $localize`Name`,
    customerId: $localize`Customer`,
    internalEventId: $localize`Event Type`,
    internalEvent: $localize`Event Type`,
    templateId: $localize`Template`,
    template: $localize`Template`,
    httpMethod: $localize`HTTP Method`,
    url: $localize`URL`,
    headers: $localize`Headers`,
    authConfigId: $localize`Auth Config`,
    transportType: $localize`Transport Type`,
    batchSize: $localize`Batch Size`,
    schedule: $localize`Schedule`,
    intervalMinutes: $localize`Interval (minutes)`,
    isEnabled: $localize`Enabled`,
    createdUtc: $localize`Created At`,
    createdBy: $localize`Created By`,
    updatedUtc: $localize`Updated At`,
    updatedBy: $localize`Updated By`,
    deletedUtc: $localize`Deleted At`,
    deletedBy: $localize`Deleted By`,
  },
});
